/* MOJITO Concierge Bubble — site-wide AI shopping assistant.
   Additive: loaded by snippets/mojito-bubble.liquid; remove that render line
   in layout/theme.liquid to disable. Talks to the mojito-returns-api worker
   (/api/bubble-session + /api/bubble-chat). Anonymous visitors only — order
   questions are routed to the returns portal page. */
(function () {
  'use strict';

  var script = document.currentScript || document.querySelector('script[data-mojito-bubble]');
  if (!script) return;
  var API = script.getAttribute('data-api') || '';
  if (!API) return;

  // The returns portal page has its own concierge — never show both.
  if (window.location.pathname.indexOf('/pages/returns-exchanges') !== -1) return;

  var isES = (script.getAttribute('data-locale') || document.documentElement.lang || 'en')
    .toLowerCase().indexOf('es') === 0;

  var T = isES ? {
    title: 'Mojito Concierge',
    teaser: '👋 ¿Te ayudo a encontrar la prenda perfecta?',
    greeting: '¡Hola! Puedo ayudarte a encontrar la prenda ideal o responder tus preguntas. ¿Qué buscas hoy?',
    chips: ['Ayúdame a elegir un look', 'Envíos y entregas', 'Devoluciones y cambios'],
    placeholder: 'Escribe tu mensaje…',
    send: 'Enviar',
    view: 'Ver',
    error: 'Algo salió mal. Inténtalo de nuevo.',
    expired: 'La sesión expiró. Inténtalo de nuevo.',
    open: 'Abrir chat de ayuda',
    close: 'Cerrar chat',
    hide: 'Ocultar el chat',
    show: 'Mostrar el chat'
  } : {
    title: 'Mojito Concierge',
    teaser: '👋 Need help finding the right piece?',
    greeting: 'Hi! I can help you find the right piece or answer questions about sizing, fabric, and shipping. What brings you in today?',
    chips: ['Help me find something', 'Shipping & delivery', 'Returns & exchanges'],
    placeholder: 'Type your message…',
    send: 'Send',
    view: 'View',
    error: 'Something went wrong. Please try again.',
    expired: 'Session expired. Please try again.',
    open: 'Open help chat',
    close: 'Close chat',
    hide: 'Hide chat',
    show: 'Show chat'
  };

  var state = {
    token: null,
    tokenExp: 0,
    sid: '',           // bubble session id (UUID) — the attribution join key
    history: [],       // {role, content} — cleaned text only
    log: [],           // render transcript: {t:'user'|'assistant',x} | {t:'cards',c:[...]}
    open: false,
    busy: false,
    turnProducts: [],  // card payloads for THIS turn's [[CARD:n]] markers
    greeted: false
  };

  // ---------- transcript persistence ----------
  // sessionStorage scope = the conversation carries across page navigations
  // and refreshes in this tab, and ends when the browser/tab is closed.
  var STORE_KEY = 'mjbChat';
  function saveChat() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        log: state.log.slice(-40),
        greeted: state.greeted,
        open: state.open
      }));
    } catch (e) { /* storage unavailable — chat stays per-page */ }
  }
  function restoreChat() {
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
    if (!data || !Array.isArray(data.log) || !data.log.length) return;
    state.log = data.log;
    state.greeted = !!data.greeted;
    data.log.forEach(function (entry) {
      if (!entry) return;
      if ((entry.t === 'user' || entry.t === 'assistant') && typeof entry.x === 'string' && entry.x) {
        addBubble(entry.t, entry.x, true);
      } else if (entry.t === 'cards' && Array.isArray(entry.c)) {
        renderCardRow(entry.c);
      }
    });
    state.history = data.log
      .filter(function (e) { return e && (e.t === 'user' || e.t === 'assistant') && e.x; })
      .map(function (e) { return { role: e.t, content: e.x }; })
      .slice(-20);
    // Conversation never got past the greeting — offer the starter chips again.
    if (state.log.length === 1) renderChips();
    if (data.open) openPanel(true);
  }

  // ---------- session token ----------
  function loadStoredToken() {
    try {
      var raw = sessionStorage.getItem('mjbToken');
      if (!raw) return;
      var d = JSON.parse(raw);
      if (d && d.token && d.exp && d.exp - Date.now() > 60000) {
        state.token = d.token;
        state.tokenExp = d.exp;
        if (typeof d.sid === 'string') state.sid = d.sid;
      }
    } catch (e) { /* storage unavailable — mint per page */ }
  }
  // ---------- Turnstile (bot check on session mint) ----------
  // Active only when the snippet carries data-turnstile-sitekey AND the
  // worker has TURNSTILE_SECRET set (either alone is a safe no-op).
  // Invisible mode: no UI ever appears. api.js loads lazily on the first
  // mint, so visitors who never engage the chat load nothing extra.
  var TS_KEY = script.getAttribute('data-turnstile-sitekey') || '';
  var tsWidgetId = null;
  var tsScriptPromise = null;
  var tsResolve = null;
  var tsInflight = null;

  function tsFire(tok) {
    var r = tsResolve;
    tsResolve = null;
    if (r) r(tok || '');
  }
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(true);
    if (tsScriptPromise) return tsScriptPromise;
    tsScriptPromise = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { resolve(true); };
      s.onerror = function () {
        // Don't cache a transient load failure for the page lifetime — a
        // later mint should retry the load (harmless when truly blocked).
        tsScriptPromise = null;
        try { if (s.parentNode) s.parentNode.removeChild(s); } catch (e) {}
        resolve(false);
      };
      document.head.appendChild(s);
    });
    return tsScriptPromise;
  }
  function getTurnstileToken() {
    if (!TS_KEY) return Promise.resolve('');
    if (tsInflight) return tsInflight;
    tsInflight = new Promise(function (resolve) {
      var settled = false;
      // The timer bounds the WHOLE chain (script load + challenge) — a
      // blackholed api.js request must not hang the chat beyond 15s.
      var timer = setTimeout(function () {
        if (!settled) { settled = true; tsResolve = null; resolve(''); }
      }, 15000);
      var finish = function (tok) {
        if (!settled) { settled = true; clearTimeout(timer); resolve(tok || ''); }
      };
      loadTurnstile().then(function (ok) {
        if (settled) return;
        if (!ok || !window.turnstile) { finish(''); return; }
        tsResolve = finish;
        try {
          if (tsWidgetId === null) {
            var host = document.createElement('div');
            host.className = 'mjb-turnstile';
            (root || document.body).appendChild(host);
            // Callbacks are fixed at render time; turnstile.reset() re-runs
            // the challenge and fires the SAME callback with a fresh token
            // (tokens are single-use, so every mint needs its own).
            tsWidgetId = window.turnstile.render(host, {
              sitekey: TS_KEY,
              callback: function (tok) { tsFire(tok); },
              'error-callback': function () { tsFire(''); },
              'unsupported-callback': function () { tsFire(''); }
            });
            if (tsWidgetId === null || tsWidgetId === undefined) { tsWidgetId = null; tsFire(''); }
          } else {
            window.turnstile.reset(tsWidgetId);
          }
        } catch (e) { tsFire(''); }
      });
    }).then(function (tok) { tsInflight = null; return tok; });
    return tsInflight;
  }

  // One mint at a time: concurrent callers (panel-open pre-warm + a fast
  // first message) must share ONE request — Turnstile tokens are single-use,
  // so two mints posting the same token would 403 the second one.
  var mintInflight = null;
  function mintToken() {
    if (mintInflight) return mintInflight;
    mintInflight = getTurnstileToken().then(function (tsTok) {
      return fetch(API + '/api/bubble-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tsTok ? { turnstileToken: tsTok } : {})
      });
    }).then(function (res) { return res.json(); }).then(function (d) {
      if (d && d.success && d.token) {
        var prevSid = state.sid;
        state.token = d.token;
        state.tokenExp = d.exp || (Date.now() + 3600000);
        state.sid = (typeof d.sid === 'string' && d.sid) ? d.sid : '';
        try { sessionStorage.setItem('mjbToken', JSON.stringify({ token: d.token, exp: state.tokenExp, sid: state.sid })); } catch (e) {}
        // Mid-session re-mint rotates the sid (2h TTL). Emit a linking event
        // so funnel reporting can coalesce the sid chain instead of seeing an
        // orphan conversion under the new sid and a dead session on the old.
        if (prevSid && state.sid && prevSid !== state.sid) {
          track('sid_rotated', { old: prevSid });
        }
        return true;
      }
      return false;
    }).catch(function () { return false; }).then(function (ok) {
      mintInflight = null;
      return ok;
    });
    return mintInflight;
  }
  function ensureToken() {
    if (state.token && state.tokenExp - Date.now() > 60000) return Promise.resolve(true);
    return mintToken();
  }

  // ---------- attribution + funnel telemetry ----------
  // Layer 1 (order-level): once a visitor ENGAGES the chat, their cart gets a
  // `_mjb_sid` attribute (the bubble session UUID — never the bearer token).
  // Shopify copies cart attributes onto the order at checkout; the admin cron
  // sweep then tags matched orders `chat-bubble` and joins revenue to chat
  // sessions in D1.
  // Layer 2 (line-level): clicking a recommendation card writes the SAME
  // sessionStorage marker the theme's other rec surfaces use
  // (mojito_rec_click_<handle>, source 'chat-bubble') and tags the card URL
  // with ?mjb=1 so open-in-new-tab survives; on the PDP the marker becomes a
  // hidden `properties[_rec_source]` input in the main product form — the
  // exact mechanism of mojito-cart-upsell.js / mojito-recommended-top, so
  // every rec source funnels through ONE property (the marker itself is
  // last-write-wins across surfaces — last touch gets line credit, matching
  // the existing surfaces' semantics; "first wins" only applies to an input
  // already injected into an open PDP form). Line properties also ride along
  // on Buy It Now, which skips the cart and therefore its attributes.
  // Telemetry: fire-and-forget beacons to /api/bubble-event (token-gated,
  // fail-open server-side). Nothing here may ever break the chat or the
  // theme — every path is wrapped and silent.
  var REC_KEY_PREFIX = 'mojito_rec_click_'; // shared with the other rec receivers
  var REC_SOURCE = 'chat-bubble';
  var REC_MAX_AGE_MS = 60 * 60 * 1000;      // 1h, matching the existing receivers

  function getSid() {
    if (state.sid) return state.sid;
    if (!state.token) return '';
    // Fallback for tokens minted before the worker returned sid separately:
    // the token body is b64url JSON {b: sid, exp}.
    try {
      var body = state.token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
      while (body.length % 4) body += '=';
      var payload = JSON.parse(atob(body));
      if (payload && typeof payload.b === 'string' && payload.b) {
        state.sid = payload.b;
      }
    } catch (e) { /* opaque token — attribution quietly off */ }
    return state.sid;
  }

  var trackCount = 0;
  var engagedSentToken = null; // page-local: token the 'engaged' beacon rode on
  function track(type, data) {
    try {
      if (!state.token || trackCount >= 60) return; // page-level safety cap
      trackCount++;
      var body = JSON.stringify({ token: state.token, events: [{ t: type, d: data || {} }] });
      // sendBeacon with a string body = a text/plain "simple" request (no
      // CORS preflight) that survives the navigation a card click starts.
      if (navigator.sendBeacon && navigator.sendBeacon(API + '/api/bubble-event', body)) return;
      fetch(API + '/api/bubble-event', { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) { /* telemetry must never break the chat */ }
  }

  var cartAttrSid = '';
  function assertCartAttribute() {
    var sid = getSid();
    if (!sid || cartAttrSid === sid) return;
    cartAttrSid = sid; // optimistic per-page dedupe; reset on failure
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: { _mjb_sid: sid } })
      }).then(function (res) {
        if (!res.ok) cartAttrSid = '';
      }).catch(function () { cartAttrSid = ''; });
    } catch (e) { cartAttrSid = ''; }
  }

  function markEngaged() {
    var done = false;
    try { done = !!sessionStorage.getItem('mjbEngaged'); } catch (e) {}
    if (!done) {
      try { sessionStorage.setItem('mjbEngaged', '1'); } catch (e) {}
      engagedSentToken = state.token;
      track('engaged', { p: String(window.location.pathname).slice(0, 120) });
    }
    // Re-assert at every engagement point: a session can outlive the cart it
    // first stamped (checkout completes → fresh cart), and the write is
    // deduped per page + sid anyway.
    assertCartAttribute();
  }

  function handleFromUrl(u) {
    var m = String(u || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  // PDP receiver: turn a card click (sessionStorage marker or ?mjb=1 param)
  // into the hidden line-item property on the main add-to-cart form.
  function injectChatAttribution(key, handle) {
    var raw = null;
    try { raw = sessionStorage.getItem(key); } catch (e) { return; }
    if (!raw) return;
    var data = null;
    try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data || data.source !== REC_SOURCE) return; // other sources belong to their own receivers
    if (Date.now() - (data.ts || 0) > REC_MAX_AGE_MS) {
      try { sessionStorage.removeItem(key); } catch (e) {}
      return;
    }
    var forms = document.querySelectorAll('form[action*="/cart/add"][data-product-form]:not([data-quickbuy-form])');
    forms.forEach(function (form) {
      var input = form.querySelector('input[name="properties[_rec_source]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_rec_source]';
        input.value = REC_SOURCE;
        form.appendChild(input);
      }
      // First-wins across rec surfaces (same convention as the other
      // receivers): if another source already claimed this add, the line
      // isn't chat-attributed — and gets no ATC event either.
      if (input.value !== REC_SOURCE) return;
      // Arm the form for the document-level capture listener below (a
      // per-form listener would run AFTER the theme's own submit handler,
      // which synchronously disables the button for its loading state — the
      // disabled guard would then swallow every legitimate add).
      form.dataset.mjbAtcKey = key;
      form.dataset.mjbAtcHandle = handle;
    });
    bindAtcCapture();
  }

  // ONE capture-phase submit listener on document: capture on an ancestor
  // runs BEFORE any listener on the form itself, so the button state we
  // check is the PRE-submit state (the theme's handler hasn't yet applied
  // its is-loading disable). Mirrors the theme's knowable-at-submit no-op
  // branches: a genuinely disabled button or the sold-out notification
  // popup adds nothing, so those submits consume no marker and count no
  // atc. A failed /cart/add AFTER this point still counts — 'atc' means
  // "attributed add attempted", which is the documented semantics.
  var atcCaptureBound = false;
  function bindAtcCapture() {
    if (atcCaptureBound) return;
    atcCaptureBound = true;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.dataset || !form.dataset.mjbAtcKey) return;
      var btn = form.querySelector('[type="submit"], [data-add-to-cart]');
      if (btn && (btn.hasAttribute('disabled') ||
        (btn.hasAttribute('data-notification-popup') && form.closest('.variant--soldout')))) return;
      try { sessionStorage.removeItem(form.dataset.mjbAtcKey); } catch (err) {}
      track('atc', { h: form.dataset.mjbAtcHandle || '' });
      assertCartAttribute();
    }, true);
  }

  function pdpAttribution() {
    var handle = handleFromUrl(window.location.pathname);
    if (!handle) return;
    var key = REC_KEY_PREFIX + handle;
    // ?mjb=<ts> arrival (open-in-new-tab — the click-time marker lives in the
    // ORIGINATING tab's sessionStorage): write the marker here too, but only
    // when the tag is fresh (<1h old — stale = shared/bookmarked link, not a
    // chat click) and there isn't already an unexpired chat marker (a
    // back-button revisit must not restart the 1h TTL).
    var pm = /[?&]mjb=(\d+)(?:&|$)/.exec(window.location.search);
    if (pm) {
      var tagTs = parseInt(pm[1], 10);
      if (tagTs && Date.now() - tagTs < REC_MAX_AGE_MS) {
        var have = null;
        try { have = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
        var haveFresh = have && have.source === REC_SOURCE && Date.now() - (have.ts || 0) < REC_MAX_AGE_MS;
        if (!haveFresh) {
          try { sessionStorage.setItem(key, JSON.stringify({ source: REC_SOURCE, ts: tagTs })); } catch (e) {}
        }
      }
      // Strip the param either way so it never persists into the address bar,
      // browser history, or copied links (keeps ?variant= etc. intact).
      try {
        var cleaned = window.location.search.replace(/([?&])mjb=\d+(&|$)/, function (m0, lead, tail) {
          return tail === '&' ? lead : '';
        });
        history.replaceState(history.state, '', window.location.pathname + cleaned + window.location.hash);
      } catch (e) { /* history API unavailable — cosmetic only */ }
    }
    injectChatAttribution(key, handle);
    // Palo Alto re-renders the product form on variant change — and a
    // connected-product option swap REPLACES the whole product-info element
    // AND replaceStates the URL to the NEW product. Re-derive the handle at
    // event time (like the reference receivers do) instead of using the
    // load-time closure, so a swapped-in product B checks marker B, not A.
    document.addEventListener('theme:product-info:loaded', function () {
      var h = handleFromUrl(window.location.pathname);
      if (h) injectChatAttribution(REC_KEY_PREFIX + h, h);
    });
  }

  // ---------- markers ----------
  // Bracket-tolerant (the model occasionally fumbles marker syntax): strips
  // [[CARD:n]] variants with extra/missing brackets, partial tails mid-stream,
  // and leftover bracket debris.
  function stripMarkers(text, partial) {
    var clean = String(text).replace(/\[+\s*CARD\s*:?\s*\d*(?:\s*\|\s*[^\]]*?)?\s*\]+/gi, '');
    if (partial) clean = clean.replace(/\[+\s*(C(A(R(D)?)?)?)?:?\s*\d*(?:\s*\|\s*[^\]]*)?\]?$/i, '');
    clean = clean.replace(/^[ \t]*[\[\],]+[ \t]*$/gm, '');
    clean = clean.replace(/[ \t]+\n/g, '\n');
    clean = clean.replace(/\n{3,}/g, '\n\n');
    clean = clean.replace(/[\s\[\],]+$/, '');
    if (!partial) {
      // Punctuation debris the model leaves where markers (or fumbled
      // markers) sat mid-sentence: "occasions , ." → "occasions."
      clean = clean.replace(/\s+([.,;:!?])/g, '$1');
      clean = clean.replace(/,+(\s*[.!?])/g, '$1');
    }
    return clean.replace(/\*\*/g, '');
  }
  function extractCardNumbers(text) {
    var out = [];
    var seen = {};
    // Optional "|Color" after the number lets the assistant open the card on a
    // specific colorway: [[CARD:1|Navy]]. Color captured up to the closing ].
    var re = /\[+\s*CARD\s*:?\s*(\d+)(?:\s*\|\s*([^\]|]+?))?\s*\]+/gi;
    var m;
    while ((m = re.exec(text)) !== null) {
      var n = parseInt(m[1], 10);
      if (n && !seen[n]) { seen[n] = 1; out.push({ n: n, color: (m[2] || '').trim() }); }
      if (out.length >= 3) break;
    }
    return out;
  }

  // Normalize a color label so a marker's color matches a swatch's name
  // ("Royal-Blue" / "royal blue" → "ROYAL BLUE").
  function normColor(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  }

  // Marker fallback: the model sometimes names products but fumbles or skips
  // the [[CARD:n]] markers entirely. A named product should always get its
  // card — match this turn's grounded products by title-word overlap.
  function fuzzyMatchCards(replyText) {
    if (!state.turnProducts.length) return [];
    var reply = String(replyText).toLowerCase();
    var matched = [];
    for (var i = 0; i < state.turnProducts.length && matched.length < 3; i++) {
      var p = state.turnProducts[i];
      if (!p || !p.title) continue;
      var title = p.title.toLowerCase();
      var words = title.split(/[^a-z0-9%]+/).filter(function (w) { return w.length > 2; });
      if (words.length < 3) continue;
      // Signal 1: overall word overlap (model cites most of the title).
      var hit = 0;
      for (var j = 0; j < words.length; j++) {
        if (reply.indexOf(words[j]) !== -1) hit++;
      }
      var overlap = hit / words.length >= 0.6;
      // Signal 2: a DISTINCTIVE consecutive title phrase appears verbatim —
      // catches abbreviated citations like "Drawstring Beach Pants" for a
      // longer catalog title. Bigrams shared by 2+ of this turn's products
      // ("long sleeve", "french cuff") prove nothing and are ignored.
      var phrase = false;
      var bgs = titleBigrams(p.title);
      for (var k = 0; k < bgs.length && !phrase; k++) {
        if (bigramOwners(bgs[k]) === 1 && reply.indexOf(bgs[k]) !== -1) phrase = true;
      }
      if (overlap || phrase) matched.push(p.n);
    }
    return matched;

    function titleBigrams(t) {
      var raw = String(t).toLowerCase().split(/\s+/);
      var out = [];
      for (var a = 0; a < raw.length - 1; a++) {
        var bg = raw[a] + ' ' + raw[a + 1];
        if (bg.length >= 11) out.push(bg);
      }
      return out;
    }
    function bigramOwners(bg) {
      var owners = 0;
      for (var b = 0; b < state.turnProducts.length; b++) {
        var tp = state.turnProducts[b];
        if (tp && tp.title && titleBigrams(tp.title).indexOf(bg) !== -1) owners++;
      }
      return owners;
    }
  }

  // ---------- DOM ----------
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  var root, launcher, panel, messagesEl, inputEl, sendBtn, teaserEl, hideBtn, tabEl;

  function build() {
    root = el('div', 'mjb-root');
    root.setAttribute('data-mojito-bubble-root', '');

    launcher = el('button', 'mjb-launcher');
    launcher.type = 'button';
    launcher.setAttribute('aria-label', T.open);
    launcher.innerHTML =
      '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>';
    launcher.addEventListener('click', function () { state.open ? closePanel() : openPanel(); });

    panel = el('div', 'mjb-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', T.title);

    var header = el('div', 'mjb-header');
    header.appendChild(el('div', 'mjb-header__title', T.title));
    var closeBtn = el('button', 'mjb-header__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', T.close);
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closePanel);
    header.appendChild(closeBtn);
    panel.appendChild(header);

    messagesEl = el('div', 'mjb-messages');
    panel.appendChild(messagesEl);

    var form = el('form', 'mjb-input');
    inputEl = el('input', 'mjb-input__field');
    inputEl.type = 'text';
    inputEl.maxLength = 400;
    inputEl.placeholder = T.placeholder;
    inputEl.setAttribute('aria-label', T.placeholder);
    sendBtn = el('button', 'mjb-input__send');
    sendBtn.type = 'submit';
    sendBtn.setAttribute('aria-label', T.send);
    sendBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"></path></svg>';
    form.appendChild(inputEl);
    form.appendChild(sendBtn);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = inputEl.value.replace(/\s+/g, ' ').trim();
      if (!text || state.busy) return;
      inputEl.value = '';
      sendMessage(text);
    });
    panel.appendChild(form);

    root.appendChild(panel);
    root.appendChild(launcher);

    // Dismiss badge on the launcher's shoulder — a SIBLING of the launcher
    // (buttons can't nest) absolutely positioned over its corner.
    hideBtn = el('button', 'mjb-hide', '×');
    hideBtn.type = 'button';
    hideBtn.setAttribute('aria-label', T.hide);
    hideBtn.addEventListener('click', collapseBubble);
    root.appendChild(hideBtn);

    document.body.appendChild(root);

    // Edge tab shown while collapsed. Lives OUTSIDE the root — a child would
    // ride off-screen with the translated root.
    tabEl = el('button', 'mjb-tab');
    tabEl.type = 'button';
    tabEl.setAttribute('aria-label', T.show);
    tabEl.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="14 6 8 12 14 18"></polyline></svg>';
    tabEl.addEventListener('click', expandBubble);
    document.body.appendChild(tabEl);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) closePanel();
    });
  }

  function openPanel(noFocus) {
    // A keypress can still reach the launcher during the collapse slide's
    // 0.3s visibility delay — never open the panel while collapsed.
    if (root.classList.contains('mjb-root--hidden')) expandBubble();
    state.open = true;
    root.classList.add('mjb-root--open');
    hideTeaser(true);
    if (!state.greeted) {
      state.greeted = true;
      addBubble('assistant', T.greeting);
      renderChips();
    }
    ensureToken();
    saveChat();
    // Restoring across a page navigation must not steal focus (mobile
    // keyboard would pop on every page) — only focus on a real open tap.
    if (!noFocus) setTimeout(function () { try { inputEl.focus(); } catch (e) {} }, 250);
  }
  function closePanel() {
    state.open = false;
    root.classList.remove('mjb-root--open');
    saveChat();
  }

  function addBubble(role, text, skipLog) {
    var b = el('div', 'mjb-msg mjb-msg--' + role, text);
    messagesEl.appendChild(b);
    scrollDown();
    if (!skipLog && (role === 'user' || role === 'assistant') && text) {
      state.log.push({ t: role, x: text });
      saveChat();
    }
    return b;
  }
  function scrollDown() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function renderChips() {
    var row = el('div', 'mjb-chips');
    T.chips.forEach(function (label) {
      var chip = el('button', 'mjb-chip', label);
      chip.type = 'button';
      chip.addEventListener('click', function () {
        removeChips();
        sendMessage(label);
      });
      row.appendChild(chip);
    });
    messagesEl.appendChild(row);
    scrollDown();
  }
  function removeChips() {
    var rows = messagesEl.querySelectorAll('.mjb-chips');
    for (var i = 0; i < rows.length; i++) rows[i].parentNode.removeChild(rows[i]);
  }

  function renderCards(cards) {
    if (!cards.length || !state.turnProducts.length) return;
    var items = [];
    cards.forEach(function (c) {
      for (var i = 0; i < state.turnProducts.length; i++) {
        var p = state.turnProducts[i];
        if (p && p.n === c.n && p.url && items.length < 3) {
          // Clone before tagging the recommended color (_rc) so it never
          // mutates the shared turnProducts payload that's persisted/restored.
          if (c.color) {
            var pc = {};
            for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) pc[k] = p[k]; }
            pc._rc = c.color;
            items.push(pc);
          } else {
            items.push(p);
          }
          break;
        }
      }
    });
    if (!items.length) return;
    renderCardRow(items);
    track('cards_shown', { h: items.map(function (p) { return handleFromUrl(p.url); }) });
    state.log.push({ t: 'cards', c: items });
    saveChat();
  }

  function renderCardRow(items) {
    // Attribution-tag every card URL once (?mjb=<render timestamp>). Tagging
    // p.url ITSELF — not the anchor — matters: the payload object is what's
    // persisted and restored across pages, and the swatch toggle rebuilds
    // card.href from raw p.url, which would wipe an anchor-only tag. The
    // timestamp (not a bare flag) keeps the param from becoming a shareable
    // attribution trigger: the PDP receiver rejects values older than 1h, so
    // a copied link stops attributing once stale, while the open-in-new-tab
    // case (click follows render within seconds) still works.
    items.forEach(function (p) {
      if (p && p.url && p.url.indexOf('mjb=') === -1) {
        p.url += (p.url.indexOf('?') !== -1 ? '&' : '?') + 'mjb=' + Date.now();
      }
    });
    var row = el('div', 'mjb-cards');
    var added = 0;
    items.forEach(function (p) {
      if (!p || !p.url || added >= 3) return;
      var card = el('a', 'mjb-card');
      card.href = p.url;
      // Card navigation = the attribution moment: write the shared rec-click
      // marker (the PDP receiver turns it into a line-item property) and log
      // the click. Swatch taps stopPropagation, so they never land here.
      var onCardNav = function (e) {
        if (e.type === 'auxclick' && e.button !== 1) return; // middle-click only
        var h = handleFromUrl(card.pathname);
        if (h) {
          try { sessionStorage.setItem(REC_KEY_PREFIX + h, JSON.stringify({ source: REC_SOURCE, ts: Date.now() })); } catch (err) {}
        }
        var vm = String(card.search || '').match(/[?&]variant=(\d+)/);
        track('card_click', { h: h, v: vm ? vm[1] : '' });
        assertCartAttribute();
      };
      card.addEventListener('click', onCardNav);
      card.addEventListener('auxclick', onCardNav);
      var img = null;
      var defaultSrc = '';
      if (p.image) {
        img = document.createElement('img');
        img.className = 'mjb-card__img';
        // NOT lazy: cards are already on-demand (max 3 per turn), and
        // loading="lazy" stalls on images inserted while the panel is
        // display:none (restored transcripts) — they never painted.
        img.decoding = 'async';
        defaultSrc = p.image + (p.image.indexOf('?') !== -1 ? '&' : '?') + 'width=300';
        img.src = defaultSrc;
        img.alt = p.alt || p.title;
        card.appendChild(img);
      }
      card.appendChild(el('div', 'mjb-card__title', p.title));
      if (p.price) card.appendChild(el('div', 'mjb-card__price', p.price));
      if (Array.isArray(p.swatches) && p.swatches.length > 1) {
        // Per-colorway thumbnails; tapping one selects that colorway IN the
        // card (image swap + link re-pointed to ?variant=), tapping it again
        // deselects. The card itself (photo/title/View) then navigates to
        // the selected variant. Spans (not anchors) — nested <a> is invalid.
        // When the assistant recommended a color (_rc), float its swatch to the
        // front so it survives the 5-swatch cap, then auto-open the card on it.
        var sws = p.swatches.slice();
        var recSwatch = null;
        if (p._rc) {
          var want = normColor(p._rc);
          var ri = -1;
          for (var r = 0; r < sws.length; r++) {
            if (sws[r] && normColor(sws[r].c) === want) { ri = r; break; }
          }
          if (ri === -1) {
            // Loose fallback: "navy" ↔ "navy blue", "royal" ↔ "royal blue".
            for (var r2 = 0; r2 < sws.length; r2++) {
              var sc = sws[r2] ? normColor(sws[r2].c) : '';
              if (sc && want && (sc.indexOf(want) !== -1 || want.indexOf(sc) !== -1)) { ri = r2; break; }
            }
          }
          if (ri > 0) { sws.unshift(sws.splice(ri, 1)[0]); }
          if (ri !== -1) recSwatch = sws[0];
        }
        var strip = el('div', 'mjb-card__swatches');
        var recNode = null;
        sws.slice(0, 5).forEach(function (s) {
          if (!s || !s.img || s.img.indexOf('https://') !== 0) return;
          var sw = el('span', 'mjb-card__swatch');
          sw.title = s.c;
          sw.setAttribute('role', 'button');
          sw.setAttribute('tabindex', '0');
          sw.setAttribute('aria-pressed', 'false');
          sw.setAttribute('aria-label', p.title + ' — ' + s.c);
          sw.style.backgroundImage = 'url("' + s.img.replace(/"/g, '') + (s.img.indexOf('?') !== -1 ? '&' : '?') + 'width=120")';
          var toggleSwatch = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var wasOn = sw.classList.contains('mjb-card__swatch--on');
            for (var k = 0; k < strip.childNodes.length; k++) {
              strip.childNodes[k].classList.remove('mjb-card__swatch--on');
              strip.childNodes[k].setAttribute('aria-pressed', 'false');
            }
            if (wasOn) {
              if (img) { img.src = defaultSrc; img.alt = p.alt || p.title; }
              card.href = p.url;
            } else {
              sw.classList.add('mjb-card__swatch--on');
              sw.setAttribute('aria-pressed', 'true');
              if (img) {
                img.src = s.img + (s.img.indexOf('?') !== -1 ? '&' : '?') + 'width=300';
                img.alt = p.title + ' — ' + s.c;
              }
              card.href = s.v ? p.url + (p.url.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + s.v : p.url;
            }
          };
          sw.addEventListener('click', toggleSwatch);
          // role=button promises keyboard operability: Enter (13) / Space (32).
          sw.addEventListener('keydown', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) toggleSwatch(e);
          });
          strip.appendChild(sw);
          if (recSwatch && s === recSwatch) recNode = { sw: sw, s: s };
        });
        if (strip.childNodes.length > 1) {
          card.appendChild(strip);
          // Pre-select the recommended colorway (image swap + variant link), as
          // if its swatch had been tapped — only once the strip actually drew.
          if (recNode && img) {
            recNode.sw.classList.add('mjb-card__swatch--on');
            recNode.sw.setAttribute('aria-pressed', 'true');
            img.src = recNode.s.img + (recNode.s.img.indexOf('?') !== -1 ? '&' : '?') + 'width=300';
            img.alt = p.title + ' — ' + recNode.s.c;
            card.href = recNode.s.v ? p.url + (p.url.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + recNode.s.v : p.url;
          }
        }
      } else if (p.colors && p.colors > 1) {
        card.appendChild(el('div', 'mjb-card__colors', p.colors + (isES ? ' colores' : ' colors')));
      }
      card.appendChild(el('div', 'mjb-card__cta', T.view + ' →'));
      row.appendChild(card);
      added++;
    });
    if (added) {
      messagesEl.appendChild(row);
      scrollDown();
    }
  }

  function showTyping() {
    var t = el('div', 'mjb-msg mjb-msg--assistant mjb-typing');
    t.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(t);
    scrollDown();
    return t;
  }

  // ---------- chat ----------
  function sendMessage(text, isRetry) {
    state.busy = true;
    removeChips();
    if (!isRetry) addBubble('user', text);
    var typing = showTyping();

    ensureToken().then(function (ok) {
      if (!ok) {
        typing.parentNode && typing.parentNode.removeChild(typing);
        addBubble('assistant', T.error);
        state.busy = false;
        return;
      }
      markEngaged();
      fetch(API + '/api/bubble-chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: state.token,
          message: text,
          history: state.history.slice(-12)
        })
      }).then(function (res) {
        if (res.status === 401 && !isRetry) {
          // Token stale — mint once and retry once. If THIS attempt's
          // markEngaged rode the rejected token, its 'engaged' beacon was
          // dropped server-side too — clear the one-shot flag so the retry's
          // markEngaged re-fires it with the fresh token. (Only when the
          // beacon went out on the exact token that just failed; an engaged
          // event delivered earlier on a good token must not double-fire.)
          if (engagedSentToken && engagedSentToken === state.token) {
            try { sessionStorage.removeItem('mjbEngaged'); } catch (e) {}
            engagedSentToken = null;
          }
          typing.parentNode && typing.parentNode.removeChild(typing);
          state.token = null;
          return mintToken().then(function (minted) {
            state.busy = false;
            if (minted) sendMessage(text, true);
            else addBubble('assistant', T.expired);
          });
        }
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (d) {
            typing.parentNode && typing.parentNode.removeChild(typing);
            addBubble('assistant', (d && d.message) || T.error);
            state.busy = false;
          });
        }
        return streamReply(res, typing).then(function () { state.busy = false; });
      }).catch(function () {
        typing.parentNode && typing.parentNode.removeChild(typing);
        addBubble('assistant', T.error);
        state.busy = false;
      });
      // Only on the first attempt — the 401 re-mint retry re-enters
      // sendMessage and would double-log the same user turn.
      if (!isRetry) {
        state.history.push({ role: 'user', content: text });
        if (state.history.length > 20) state.history = state.history.slice(-20);
      }
    });
  }

  function streamReply(res, typing) {
    state.turnProducts = [];
    var reader = res.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    var fullText = '';
    var bubble = null;

    // Watchdog: a black-holed upstream stream would otherwise pend read()
    // forever and leave the input dead behind the busy flag. Cancelling the
    // reader resolves the pending read as done → finish() runs with whatever
    // text arrived (or the soft error if none did).
    var watchdog = null;
    function armWatchdog() {
      if (watchdog) clearTimeout(watchdog);
      watchdog = setTimeout(function () {
        try { reader.cancel(); } catch (e) {}
      }, 60000);
    }
    armWatchdog();

    function handleLine(line) {
      line = line.replace(/\r$/, '');
      if (line.indexOf('data: ') !== 0) return;
      var payload = line.slice(6);
      if (payload === '[DONE]') return;
      var d;
      try { d = JSON.parse(payload); } catch (e) { return; }
      if (d && d.mojito_products) {
        state.turnProducts = d.mojito_products;
        return;
      }
      var tok = d && d.choices && d.choices[0] && d.choices[0].delta && d.choices[0].delta.content;
      if (tok) {
        fullText += tok;
        if (!bubble) {
          if (typing.parentNode) typing.parentNode.removeChild(typing);
          bubble = addBubble('assistant', '');
        }
        bubble.textContent = stripMarkers(fullText, true);
        scrollDown();
      }
    }

    function pump() {
      return reader.read().then(function (result) {
        if (result.done) {
          if (watchdog) clearTimeout(watchdog);
          buffer.split('\n').forEach(handleLine);
          finish();
          return;
        }
        armWatchdog();
        buffer += decoder.decode(result.value, { stream: true });
        var idx;
        while ((idx = buffer.indexOf('\n')) !== -1) {
          handleLine(buffer.slice(0, idx));
          buffer = buffer.slice(idx + 1);
        }
        return pump();
      });
    }

    function finish() {
      var clean = stripMarkers(fullText, false);
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      if (!clean && !bubble) {
        // Nothing streamed — show a soft error rather than an empty bubble.
        addBubble('assistant', T.error);
        return;
      }
      if (bubble) {
        if (clean) bubble.textContent = clean;
        else if (bubble.parentNode) bubble.parentNode.removeChild(bubble);
      } else if (clean) {
        addBubble('assistant', clean, true); // logged below with the stream path
      }
      if (clean) {
        state.history.push({ role: 'assistant', content: clean });
        // The streaming bubble was created empty (unlogged) — log the final text.
        state.log.push({ t: 'assistant', x: clean });
        saveChat();
      }
      var cards = extractCardNumbers(fullText);
      if (!cards.length && clean) cards = fuzzyMatchCards(clean).map(function (n) { return { n: n, color: '' }; });
      renderCards(cards);
    }

    return pump().catch(function () {
      if (watchdog) clearTimeout(watchdog);
      if (typing.parentNode) typing.parentNode.removeChild(typing);
      if (!bubble) addBubble('assistant', T.error);
    });
  }

  // ---------- hide / edge tab ----------
  // Collapsing slides the whole bubble off the right edge and slides in a slim
  // edge tab; expanding reverses it. Persisted per tab-session so the choice
  // sticks across page navigations but resets on a fresh visit. The panel is
  // force-closed BEFORE the root transforms — the mobile panel is
  // position:fixed, and a transformed ancestor would become its containing
  // block and misplace it.
  function collapseBubble(evt) {
    // Arm the slide transitions when there's an argument (see the .mjb-anim
    // comment in the CSS). On the init-restore path restoreChat has already
    // forced a layout (scrollHeight reads), so an armed transition would
    // replay the 0.3s slide-out on every page load instead of restoring
    // already-hidden — that path calls collapseBubble() with no argument.
    // Only a real user DOM event (a click on the hide badge) moves focus to
    // the tab; the auto-tuck intro passes a plain flag so it slides WITHOUT
    // yanking focus or scrolling the page under the visitor.
    var userGesture = evt && typeof evt.type === 'string' && evt.type.length > 0;
    // Preserve tab order: if focus was resting on the launcher/hide badge (a
    // keyboard or SR user), forward it to the tab even on the auto-tuck path —
    // .mjb-root--hidden goes visibility:hidden and would otherwise drop focus
    // to <body>. When nothing here is focused, the auto-tuck stays hands-off.
    var hadFocus = document.activeElement === launcher || document.activeElement === hideBtn;
    if (evt) {
      root.classList.add('mjb-anim');
      tabEl.classList.add('mjb-anim');
    }
    hideTeaser(true);
    if (state.open) closePanel();
    root.classList.add('mjb-root--hidden');
    tabEl.classList.add('mjb-tab--on');
    try { sessionStorage.setItem('mjbCollapsed', '1'); } catch (e) {}
    if (userGesture || hadFocus) { try { tabEl.focus({ preventScroll: true }); } catch (e) {} }
  }
  function expandBubble(evt) {
    root.classList.add('mjb-anim');
    tabEl.classList.add('mjb-anim');
    root.classList.remove('mjb-root--hidden');
    tabEl.classList.remove('mjb-tab--on');
    try { sessionStorage.removeItem('mjbCollapsed'); } catch (e) {}
    if (evt) { try { launcher.focus({ preventScroll: true }); } catch (e) {} }
  }

  // ---------- landing intro ----------
  // First fresh landing of the tab-session: let the launcher sit a moment so
  // the visitor notices it, give it one self-playing "pop" (the hover pose,
  // animated), then slide it to the edge tab so it's out of the way. Runs at
  // most once per session and never over an engaged or already-collapsed
  // state — so a mid-conversation page navigation won't replay it.
  function runLandingIntro() {
    var seen = false;
    try { seen = !!sessionStorage.getItem('mjbIntroDone'); } catch (e) {}
    if (seen) return;
    // Already engaged (panel open, greeted, or restored transcript) or already
    // collapsed earlier this session — nothing to introduce.
    if (state.open || state.greeted || state.log.length) return;
    if (root.classList.contains('mjb-root--hidden')) return;
    // Claim the one-shot up front: even if the visitor engages mid-intro, the
    // next page in this session must not replay it.
    try { sessionStorage.setItem('mjbIntroDone', '1'); } catch (e) {}

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    // The timer fires unconditionally, so both the delay body and the tuck
    // handler must re-test the FULL engagement guard (not just open/hidden):
    // the visitor can open then close the panel inside the settle+pop window,
    // which leaves open=false and not-hidden but greeted=true / log populated —
    // we must not pop or auto-tuck a bubble they already used.
    function engagedOrGone() {
      return state.open || state.greeted || state.log.length ||
        root.classList.contains('mjb-root--hidden');
    }

    // Beat 1: settle delay so the page paints and the eye lands on content
    // before the bubble moves in the periphery.
    setTimeout(function () {
      if (engagedOrGone()) return;
      // Reduced motion: skip the pop; tuck quietly (CSS also no-ops the slide).
      if (reduce) { collapseBubble(true); return; }

      var fallback = null;
      var tuck = function (e) {
        // Ignore animationend bubbling from any other animation on the launcher.
        if (e && e.type === 'animationend' && e.animationName &&
            e.animationName.indexOf('mjb-attention') === -1) return;
        launcher.removeEventListener('animationend', tuck);
        if (fallback) { clearTimeout(fallback); fallback = null; }
        launcher.classList.remove('mjb-launcher--attention');
        if (engagedOrGone()) return;
        collapseBubble(true); // animated slide, no focus/scroll (see collapseBubble)
      };
      launcher.addEventListener('animationend', tuck);
      // Fallback if animationend never fires (e.g. the tab was backgrounded so
      // the animation never ran) — a touch longer than the 1.4s keyframe.
      fallback = setTimeout(tuck, 1700);
      launcher.classList.add('mjb-launcher--attention');
    }, 2200);
  }

  // ---------- proactive teaser ----------
  function showTeaser() {
    var done = false;
    try { done = !!sessionStorage.getItem('mjbTeaserDone'); } catch (e) {}
    if (done || state.open || root.classList.contains('mjb-root--hidden')) return;
    teaserEl = el('div', 'mjb-teaser');
    var txt = el('button', 'mjb-teaser__text', T.teaser);
    txt.type = 'button';
    txt.addEventListener('click', function () {
      hideTeaser(true);
      openPanel();
    });
    var x = el('button', 'mjb-teaser__close', '×');
    x.type = 'button';
    x.setAttribute('aria-label', T.close);
    x.addEventListener('click', function () { hideTeaser(true); });
    teaserEl.appendChild(txt);
    teaserEl.appendChild(x);
    root.appendChild(teaserEl);
    launcher.classList.add('mjb-launcher--pulse');
    setTimeout(function () { hideTeaser(true); }, 12000);
  }
  function hideTeaser(remember) {
    if (teaserEl && teaserEl.parentNode) teaserEl.parentNode.removeChild(teaserEl);
    teaserEl = null;
    if (launcher) launcher.classList.remove('mjb-launcher--pulse');
    if (remember) { try { sessionStorage.setItem('mjbTeaserDone', '1'); } catch (e) {} }
  }

  // ---------- init ----------
  function init() {
    // Double-render guard: if the snippet ever ends up included twice, only
    // the first instance builds a bubble.
    if (document.querySelector('[data-mojito-bubble-root]')) return;
    loadStoredToken();
    // PDP attribution receiver runs on every product page — it needs no
    // bubble DOM, only the stored token/markers.
    pdpAttribution();
    build();
    restoreChat();
    // Re-apply a collapse from earlier in this session AFTER restoreChat —
    // it force-closes any restored-open panel. Classes land in the same task
    // as build(), before first paint, so there's no slide animation on load.
    var collapsed = false;
    try { collapsed = !!sessionStorage.getItem('mjbCollapsed'); } catch (e) {}
    if (collapsed) collapseBubble();
    // Landing intro (notice-then-tuck) supersedes the proactive teaser on a
    // fresh visit — it self-guards to run at most once and only over an
    // un-engaged, un-collapsed bubble; the teaser then no-ops while hidden.
    runLandingIntro();
    setTimeout(showTeaser, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* MOJITO: scroll-to-top button — keep it clear of the PDP sticky cart-bar.
   Independent of the chat bubble above (its own IIFE) so it runs even when the
   bubble bails. The scroll-top button is a light-DOM theme element pinned
   bottom-right; on product pages the theme's sticky .cart-bar (options + Add to
   Cart) slides up on scroll into the same bottom strip. We lift the button to
   sit just above the bar while it's up — measuring the bar's actual on-screen
   intrusion so it works for the taller mobile bar and the desktop bar alike.
   No .cart-bar on the page (every non-product template) → no-op. */
(function () {
  'use strict';
  var BASE = 18; // resting bottom offset — MUST match .btn--scroll-top in the CSS (margin:0)
  var GAP = 10;  // breathing room between the button and the bar's top edge
  var btn = null, bar = null, boundBar = null, following = 0, followUntil = 0, lastApplied = -1;

  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

  // Re-query a cached node once it's gone: a connected/combined-listing option
  // swap (e.g. Big & Tall) REPLACES the product form, detaching the old
  // cart-bar — a stale ref reads a 0-size rect and silently stops lifting. Also
  // move the transitionend listener onto whichever bar is current.
  function resolve() {
    if (!btn || !btn.isConnected) { btn = document.querySelector('.btn--scroll-top'); lastApplied = -1; }
    if (!bar || !bar.isConnected) { bar = document.querySelector('.cart-bar'); }
    if (bar !== boundBar) {
      if (boundBar) boundBar.removeEventListener('transitionend', apply);
      if (bar) bar.addEventListener('transitionend', apply);
      boundBar = bar;
    }
    return btn && bar;
  }
  function apply() {
    if (!resolve()) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = bar.getBoundingClientRect();
    // How far the bar covers up from the viewport bottom (0 when parked below).
    var intrude = Math.max(0, vh - r.top);
    // Continuous: rest at BASE, then track the bar up as soon as intrude+GAP
    // would exceed it — Math.max (not a threshold) avoids a step/pop at the edge.
    var target = (r.height > 0) ? Math.max(BASE, Math.round(intrude + GAP)) : BASE;
    if (target === lastApplied) return; // skip redundant per-frame writes
    // Inline !important outranks the stylesheet !important, so this always wins.
    btn.style.setProperty('bottom', target + 'px', 'important');
    lastApplied = target;
  }
  // rAF follow-loop: track the bar every frame while scrolling AND for a short
  // tail afterward, so a scroll that stops mid-slide keeps following the bar's
  // ~0.3s animation to rest instead of snapping. Self-terminates when idle.
  function tick() {
    apply();
    if (now() < followUntil) following = requestAnimationFrame(tick);
    else following = 0;
  }
  function schedule() {
    followUntil = now() + 420;
    if (!following) following = requestAnimationFrame(tick);
  }
  function start() {
    // .cart-bar exists in the DOM on product pages even while parked off-screen;
    // its absence means a non-product template — nothing to guard against.
    if (!document.querySelector('.cart-bar')) return;
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    // A connected-listing swap replaces the cart-bar node — drop the stale refs
    // and re-sync against the freshly rendered bar.
    document.addEventListener('theme:product-info:loaded', function () { bar = null; btn = null; schedule(); });
    apply();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
